import VideoChatView from './VideoChatView';

export default VideoChatView;
